import React, { useState } from "react";
import { Box, useMediaQuery, useTheme } from "@mui/material";
import Sidebar from "./Sidebar";
import TopBar from "./TopBar";

const drawerWidth = 200;
const miniWidth = 62;

const Layout = ({ children }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const [sidebarOpen, setSidebarOpen] = useState(!isMobile);
  const [miniVariant, setMiniVariant] = useState(true);

  const toggleSidebar = () => setSidebarOpen((prev) => !prev);
  const toggleMini = () => setMiniVariant((prev) => !prev);

  return (
    <Box sx={{ display: "flex", height: "100vh", overflow: "hidden" }}>
      <TopBar onToggleSidebar={toggleSidebar} />

      {sidebarOpen && (
        <Sidebar
          open={sidebarOpen}
          drawerWidth={drawerWidth}
          miniVariant={miniVariant}
          toggleMini={toggleMini}
          variant={isMobile ? "temporary" : "persistent"}
          onClose={toggleSidebar}
        />
      )}

      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: 3,
          mt: '54px', // fixed AppBar height
          minHeight: 'calc(100vh - 64px)',
          bgcolor: 'background.default',
          color: 'text.primary',
          overflowX: 'hidden',
        }}
      >
        {children}
      </Box> 

    </Box>
  );
};

export default Layout;
